import {
  Award, Network, CalendarClock, Boxes, FileCheck2, Banknote, Landmark, Handshake,
  Globe2, ShieldCheck, FileText, Receipt, Package, Repeat, Wheat, Leaf, BadgeCheck,
  TrendingUp, Mail, ArrowRight, ArrowUpRight, MapPin, Sprout, ScanSearch,
} from "lucide-react";
import { Link } from "react-router-dom";
import { Container, Eyebrow, LeafBackdrop } from "@/components/common";
import { COMPANY } from "@/data/content";

const MAP = {
  Award, Network, CalendarClock, Boxes, FileCheck2, Banknote, Landmark, Handshake,
  Globe2, ShieldCheck, FileText, Receipt, Package, Repeat, Wheat, Leaf, BadgeCheck,
  TrendingUp, MapPin, Sprout, ScanSearch,
};

export const Icon = ({ name, ...props }) => {
  const C = MAP[name] || Sprout;
  return <C {...props} />;
};

// Inner-page hero band (navy with subtle gold pattern)
export const PageHero = ({ eyebrow, title, intro, image }) => (
  <section className="relative overflow-hidden hero-navy-gradient">
    <div className="absolute inset-0 opacity-[0.5]" aria-hidden="true">
      <div className="absolute -right-10 -top-10 h-[420px] w-[420px] rounded-full" style={{ background: "radial-gradient(circle, rgba(58,187,176,0.10) 0%, rgba(2,6,6,0) 70%)" }} />
    </div>
    {image && (
      <div className="absolute inset-0" aria-hidden="true">
        <img src={image} alt="" className="h-full w-full object-cover opacity-[0.14]" />
        <div className="absolute inset-0 hero-navy-gradient opacity-90" />
      </div>
    )}
    {/* Consistent leaf/wreath watermark (matches Home hero) */}
    <div className="pointer-events-none absolute inset-0 overflow-hidden" aria-hidden="true">
      <LeafBackdrop size={540} className="-right-28 -top-24 opacity-50" />
      <LeafBackdrop size={340} className="right-1/3 -bottom-32 opacity-25" color="rgba(65,225,154,0.07)" />
    </div>
    <Container wide className="relative py-16 sm:py-20 lg:py-28">
      <div className="max-w-3xl">
        {eyebrow && <Eyebrow onNavy>{eyebrow}</Eyebrow>}
        <h1 className="mt-5 font-serif text-4xl sm:text-5xl lg:text-6xl leading-[1.05] tracking-[-0.02em] text-white">
          {title}
        </h1>
        {intro && (
          <p className="mt-6 max-w-2xl font-sans text-base sm:text-lg leading-relaxed" style={{ color: "var(--pt-muted-on-navy)" }}>
            {intro}
          </p>
        )}
      </div>
    </Container>
    <div className="gold-hairline" />
  </section>
);

// Reusable navy CTA band
export const CTABand = ({ heading, subtext }) => (
  <section data-testid="page-cta-band" className="relative overflow-hidden hero-navy-gradient">
    <div className="gold-hairline" />
    <Container className="py-16 sm:py-20 lg:py-24 text-center">
      <div className="mx-auto flex max-w-3xl flex-col items-center">
        <div className="mb-5"><Eyebrow onNavy>Prince Trading Impex</Eyebrow></div>
        <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl leading-[1.1] tracking-[-0.015em] text-white">
          {heading}
        </h2>
        {subtext && (
          <p className="mt-6 font-sans text-base sm:text-lg leading-relaxed" style={{ color: "var(--pt-muted-on-navy)" }}>
            {subtext}
          </p>
        )}
        <div className="mt-9 flex flex-col sm:flex-row items-center gap-4">
          <a
            href={`mailto:${COMPANY.email}`}
            data-testid="page-cta-band-button"
            className="inline-flex items-center gap-2 rounded-full px-7 py-3.5 font-sans text-sm font-semibold transition-all"
            style={{ background: "linear-gradient(90deg,#3ABBB0,#41E19A)", color: "#020606", boxShadow: "0 6px 20px rgba(58,187,176,0.35)" }}
            onMouseEnter={(e) => (e.currentTarget.style.filter = "brightness(1.08)")}
            onMouseLeave={(e) => (e.currentTarget.style.filter = "brightness(1)")}
          >
            <Mail size={16} /> Email Us
          </a>
        </div>
      </div>
    </Container>
  </section>
);

export { ArrowRight, ArrowUpRight, Mail };
